module.exports = __webpack_public_path__ + "img/logo-1.2ff158a5.png";